module.exports = __webpack_public_path__ + "img/icon-personal-map.1b20149c.png";